<template>
  <div style="margin-left:auto;margin-right:auto;margin-top:40px;margin-bottom:40px">
    <p style="text-align:center;color:#7a7157">See online portfolios of the world's leading illustrators 
      <a style="color:#7a7157;text-decoration:underline" href="https://www.illustrationx.com/">here</a>.
    </p>
    <div style="width:590px;background-color:#ffffff;margin-left:auto;margin-right:auto;border:1px solid #000000;margin-top:50px;box-shadow:0 0 12px rgba(0,0,0,0.3)">
      <div style="padding:35px;text-align:center">
        <div style="font-size:18px;color:#7a7157;margin-bottom:40px;letter-spacing:3px">
          COMING TO A SCREEN NEAR YOU . . .
        </div>
        <img :src="$assetUrl('big-x-shadow.png')" />
        <div style="font-size:41px;margin:20px 0">
          Illustration is becoming
        </div>
        <div>
          <img :src="$assetUrl('launch-logo.png')" />
        </div>
        <div style="font-size:28px;margin:30px 0">
          We've added an <span style='color:#ce0e2d;font-weight:700'>X</span> to our name to stand for that unique and important extra edge that we bring to all your projects with:
        </div>
        <div style="font-size:20px;font-weight:700;margin-top:30px;margin-bottom:5px;color:#ce0e2d;letter-spacing:0.5px">
          AN UNRIVALLED VARIETY AND CHOICE OF ARTISTS
        </div>
        <div style="font-size:22px;margin:10px 9">
          We now connect you to the most diverse collection of top illustration and animation talent in the world.
        </div>
        <div style="font-size:20px;font-weight:700;margin-top:30px;margin-bottom:5px;color:#ce0e2d;letter-spacing:0.5px">
          A BRAND NEW, EXPERTLY CURATED WEBSITE
        </div>
        <div style="font-size:22px;margin:10px 9">
          With innovative features to help you find exactly the style, medium and artist you are looking for.
        </div>
        <div style="font-size:20px;font-weight:700;margin-top:30px;margin-bottom:5px;color:#ce0e2d;letter-spacing:0.5px">
          EXCEPTIONAL GLOBAL COVERAGE AND SERVICE
        </div>
        <div style="font-size:22px;margin:10px 9">
          With expert local agents in nine offices across four continents, ready to identify 
          the hottest emerging talent where ever it pops up, and to help you make the most of your commission wherever you are.
        </div>
        <div style="font-size:23px;margin-top:30px">
          Check it out today:
        </div>
        <div style="font-size:28px">
          <div style="margin:5px 0"><a href="https://www.illustrationx.com" style="color:#0071bc">www.illustrationx.com</a></div>
          <div style="margin:5px 0"><a href="https://www.animationx.com" style="color:#0071bc">www.animationx.com</a></div>
        </div>
        <div style="font-size:41px;margin:30px 0">
          Welcome to the future of 
          Illustration and Animation
        </div>
      </div>
      <div style="text-align:center;color:#7a7157;margin:0 35px;padding-top:35px;padding-bottom:45px;border-top:1px solid #7a7157">
        <p>Follow us</p>
        <div>
          <a href="https://www.pinterest.com/illustrationltd/"><img :src="$assetUrl('pinterest.png')" /></a> &nbsp;
          <a href="https://www.facebook.com/IllustrationLtd"><img :src="$assetUrl('facebook.png')" /></a> &nbsp;
          <a href="https://twitter.com/_illustrationx"><img :src="$assetUrl('twitter.png')" /></a> &nbsp;
          <a href="https://www.linkedin.com/company/illustrationx"><img :src="$assetUrl('linkedin.png')"/></a> &nbsp;
          <a href="https://www.instagram.com/illustrationweb/"><img :src="$assetUrl('instagram.png')" /></a>
        </div>
        <div style="padding:12px 0">
          This enewsletter was sent to you by
        </div>
        <div style="padding:12px 0">
          <img :src="$assetUrl('logo-footer.png')" />
        </div>
        <div style="padding:6px 0">
          with offices in 
        </div>
        <div style="padding:6px 0">
          UK | South America | USA | France 
        </div>
        <div style="padding:6px 0">
          Germany | China | Australia | India 
        </div>
        <div style="padding:16px 0 6px 0">
          <a style="text-decoration:none;color:#7a7157" href="mailto:hello@illustrationx.com">hello@illustrationx.com</a> 
        </div>
        <div style="padding:6px 0">
          <a style="color:#ce0e2d;font-weight:500;text-decoration:none" href="https://www.illustrationx.com">www.illustrationx.com</a> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>